import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { BaseEstimateStatusService } from '@http/clients/reporting-app/base-estimate-status.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-project-status-editor',
    templateUrl: './reporting-project-status-editor.component.html',
    styleUrls: ['./reporting-project-status-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportingProjectStatusEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly baseEstimateStatusService: BaseEstimateStatusService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    async ngOnInit(): Promise<void> {
        this.items = await this.baseEstimateStatusService.getAll();
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (!ready || !this.items?.length) return;

            if (this.bindingProperty?.length && Array.isArray(this.bindingProperty)) {
                // Normalize ids to avoid number/string mismatches from API/editor contexts.
                const selectedIds = new Set(this.bindingProperty.map((id) => Number(id)));
                this.selectedItems = this.items.filter((item) => selectedIds.has(Number(item.id)));
            } else {
                this.selectedItems = [];
            }
        });
    }

    onSelectedItemsChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }
}
